<template>
    <div class="product-family product-family--inno  page">

        <!-- Hero -->        
        <div class="hero hero--inno" v-custom-cursor>        
            <div class="hero__content container" 
                :class="[{'animate-flip': flipHero}, {'animate-flip-reverse': !flipHero}]"
                @click="flipHero = !flipHero"
            >            
                <div class="hero__content__inside d-flex justify-content-between align-items-center text-center h-full">
                    <h3 class="hero__subtitle">Felbontás előtt<br/> <span>fordítsd meg</span></h3>
                    <img src="@/assets/images/Inno/SOPRONI_Inno.png" alt="Szűretlen Lager" class="img-fluid product-img" />
                    <div class="hero__title">
                        <img src="/mainassets/img/logo-white-header-2x.f264e9f9.png" alt="Soproni" class="img-fluid " />
                        <h1 >szűretlen<br/> lager</h1>
                    </div>                                        
                </div>
            </div>

        </div>

        <!-- Description -->
        <div class="container inno__description">
            <div class="row">
                <div class="col-lg-5">
                    <img src="@/assets/images/Inno/inno_main.jpg" alt="Szűretlen Lager" class="img-fluid" />
                </div>
                <div class="col-lg-6 offset-lg-1">
                    <h3>MIÉRT SZÜLETETT MEG A TERMÉK?</h3>
                    <p>A <b>limitált kiadású Soproni Szűretlen</b> sört márkánk fennállásának
                    130. évfordulójára alkottuk meg. Szándékunk, hogy ezzel a különleges
                    főzettel, melyben a tradíció és az innováció tökéletes harmóniában
                    találkozik, egy népszerű, minden nemhez és generációhoz szóló
                    terméket hozzunk létre.</p>
                    <h3>A TERMÉK TÍPUSA</h3>
                    <p>Évfordulós újdonságunkat a klasszikus
                    lagerünkből fejlesztettük, a végeredmény
                    pedig egy <b>friss, komlós-citrusos</b> karakterjegyeket
                    hordozó sörkülönlegesség lett.
                    A lager alapot megtartva, a szűrést elhagyva
                    egy <b>testesebb, opálos</b> megjelenésű, <b>5%-os
                    alkoholtartalmú</b> sört kreáltunk. A Szűretlen
                    lager <b>citrusos</b> zöngéje üde lendületet ad,
                    textúrája <b>frissítő</b> ízvilágot eredményez, így
                    tökéletesen illeszkedik a mai sörkultúra
                    kifinomult elvárásaihoz. A Soproni Szűretlen Lager elérhető lesz a polcokon dobozos és üveges formában, a vendéglátóhelyeken pedig csapon is!</p>
                </div>
            </div>
        </div>

        <Brothers 
            :brothers="brothers" 
            v-if="brothers.length > 0" 
            :currentProdFamily="currentProdFamily" 
            v-inview="'fade-up'"            
        />        

    </div>
</template>

<script>
import customCursor from '@/functions/customCursor.js'  // Egyedi kurzor
import Brothers from '@/components/pages/productDetails/Brothers.vue'

export default {
    directives: {
        customCursor        
    },
    components:{
        Brothers
    },
    data(){
        return{
            flipHero: false,
            currentProdFamily:{                
                name: 'Soproni Szűretlen Lager',
                slug: 'szuretlen-lager',
                identifier: 'inno',
                css: 'inno',                
            },
            brothers:[
                {
                    id: '1',
                    name: 'dobozos',
                    short_description: 'Miért szerepel a Soproni logó fejjel lefelé, valami nem stimmel? Épp ellenkezőleg! Az új termékhez jár egy fogyasztási rituálé is! Felbontás előtt egyetlen apró mozdulat teszi még teljesebbé az élményt: fordítsd meg egyszer a dobozt, ne rázd, csak hagyd, hogy az élesztő teljes pompájában kibontakozhasson.',
                    slug: '',
                    other_in_family_image: '/content/inno/dobozos_other_badge.png',
                    main_image: '/content/inno/szuretlen-doboz-thumb-2x.png',
                    video: '/content/inno/SOPRONI_doboz.mp4'                             
                },
                {
                    id: '2',
                    name: 'üveges',
                    short_description: 'A palack esetében pedig mielőtt pohárba töltenéd az üveg tartalmát, az alján lévő folyadékot forgasd körbe, hogy az esetlegesen leülepedett élesztő újra összekeveredjen a sörrel.',
                    slug: '',
                    other_in_family_image: '/content/inno/uveges_other.png',
                    main_image: '/content/inno/szuretlen-uveges-thumb-2x.png' ,
                    text_title: 'forgasd körbe',
                    video: '/content/inno/SOPRONI_palack.mp4'                   
                },
                {
                    id: '3',
                    name: 'csapolt',
                    short_description: 'Élvezd frissen csapolva a vendéglátóhelyeken!',
                    slug: '',
                    other_in_family_image: '/content/inno/szuretlen.png',
                    main_image: '/content/inno/szuretlen-pohar-2x.png' ,
                    text_title: 'Frissen csapolva'
                }
            ]
        }
    },
    created(){                
        let _this = this

        window.addEventListener("scroll", function(){
            _this.scrollDirection()
        }, false);
    },    
    destroyed(){
        window.removeEventListener("scroll", this.scrollDirection, false);
    },
}
</script>
